<template>
  <div />
</template>

<script>
import dataloader from 'components/auth/dataloader'

export default {
  emits: ['ready', 'revert'],
  async mounted () {
    let success = true
    if (!dataloader.checkLoaded()) {
      success = await dataloader.loadUserData(false)
    }
    else {
      dataloader.setDone()
    }

    if (success) {
      this.$emit('ready')
    }
  },
  beforeUnmount () {
    this.$emit('revert')
  }
}
</script>
